<div class="teranet-padding">
  <Teranet-PageTitle [PageTitle]="'Reset Password'"></Teranet-PageTitle>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div class="teranet-padding" fxFlex="100">
    <form [formGroup]="resetPasswordForm" #resetPasswordFormRef="ngForm">
      <div fxLayout="row wrap">
        <div class="form-group-flex-column">
          <mat-label>New Password</mat-label>
          <mat-form-field appearance="outline">
            <input matInput
                   data-lpignore="true"
                   formControlName="newPassword"
                   required />
            <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('required')">
              {{ passwordErrorMessage.NEW_PASSWORD_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('pattern')">
              {{ passwordErrorMessage.IS_NOT_PASSWORD }}
              <div class="password-hint">
                <div id="divPasswordInfo">
                  <strong>Password</strong> must meet the following minimum password strength requirements:<br />
                  <ul>
                    <li>Contain at least 1 lowercase character</li>
                    <li>Contain at least 1 special character (@ % + \ / ! $ &amp; ? [ ])</li>
                    <li>Contain at least 1 digit</li>
                    <li>Contain at least 1 uppercase character</li>
                    <li>Does not contain any characters other than those mentioned above</li>
                    <li>At least 10 characters in length</li>
                  </ul>
                </div>
              </div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group-flex-column">
          <mat-label>Confirm New Password</mat-label>
          <mat-form-field appearance="outline">
            <input matInput
                   data-lpignore="true"
                   formControlName="confirmNewPassword"
                   [errorStateMatcher]="matcher" />
            <mat-error *ngIf="resetPasswordForm.get('confirmNewPassword').hasError('required')">
              {{ passwordErrorMessage.CONFIRM_PASSWORD_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.hasError('mustMatch')">
              {{ passwordErrorMessage.PASSWORD_MUST_MATCH }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
<div fxLayout="row wrap" fxLayoutAlign="end">
  <button mat-raised-button class="theme-button" type="submit" [disabled]="resetPasswordForm.invalid" (click)="resetPassword(resetPasswordFormRef)">
    Change Password
  </button>
  <button mat-raised-button class="plain-button" type="reset" (click)="onClose()">Cancel</button>
</div>
